import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClaimsManagementComponent } from './claims-management.component';
import { AddClaimComponent } from '../add-claim/add-claim.component';

const claimsManagementRoutes: Routes = [
  { path: '', component: ClaimsManagementComponent },
];

@NgModule({
  declarations: [ClaimsManagementComponent, AddClaimComponent],

  imports: [
    CommonModule,
    RouterModule.forChild(claimsManagementRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class ClaimsManagementModule {}
